import { render, staticRenderFns } from "./AliveModal.vue?vue&type=template&id=43eda20e&scoped=true&"
import script from "./AliveModal.vue?vue&type=script&lang=js&"
export * from "./AliveModal.vue?vue&type=script&lang=js&"
import style0 from "./AliveModal.vue?vue&type=style&index=0&id=43eda20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43eda20e",
  null
  
)

export default component.exports